module.exports = __webpack_public_path__ + "img/icon-setp-2.6b78a9cb.svg";